import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { useUser } from "@/providers/user";
import { Bell } from "lucide-react";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Separator } from "../ui/separator";
import { SimpleTooltip } from "../ui/simple-tooltip";
import { NotificationItem } from "./item";

export function NotificationPopover({}: {}) {
    const { notification_summary, check_all_new_notifications, mark_all_notifications_as_seen } = useUser();

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open) {
            check_all_new_notifications();
        }
    }, [open]);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <div className={cn("relative flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100", (notification_summary?.new_count || 0) > 0 && "text-red-500 hover:bg-red-50")}>
                    <SimpleTooltip message="Notifications" delayDuration={300} skipDelayDuration={300}>
                        <div className="flex h-8 items-center justify-center rounded-full  text-slate-500" onClick={() => setOpen(!open)}>
                            <Bell className="text-gray-700" size={20} strokeWidth={1.5} />
                        </div>
                    </SimpleTooltip>
                    {(notification_summary?.unseen_count || 0) > 0 && (
                        <>
                            <div className="absolute right-0 top-0 flex h-4 min-w-4 items-center justify-center rounded-full  bg-red-700 px-0.5 text-[10px] font-semibold text-white">
                                {notification_summary?.unseen_count}
                            </div>
                            <div className="absolute right-0 top-0 flex h-4 min-w-4 animate-ping items-center justify-center rounded-full  bg-red-700 px-0.5 text-[10px] font-semibold text-white" />
                        </>
                    )}
                </div>
            </PopoverTrigger>
            <PopoverContent className="mr-10 w-96 p-0" align="start">
                <div className="flex items-center justify-between border-b px-4 py-3">
                    <h3 className="text-sm font-semibold">Notifications</h3>
                    <div className="cursor-pointer text-xs text-blue-500 underline-offset-4 hover:underline" onClick={() => mark_all_notifications_as_seen()}>
                        Tout marquer comme lu
                    </div>
                </div>

                <ul className="space-y-2 px-4">
                    {notification_summary?.recent_notifications.map((n, i) => (
                        <React.Fragment key={`notification_${n.id}_${i}`}>
                            {i != 0 && <Separator />}
                            <li className="space-y-2 first:pt-2">
                                <NotificationItem notification={n} compact={true} link={true} onRedirect={() => setOpen(false)} />
                            </li>
                        </React.Fragment>
                    ))}
                    <li className="flex items-center justify-center">
                        <div className="flex w-full cursor-pointer border-t py-3 text-xs text-blue-500 underline-offset-4 hover:underline" onClick={() => setOpen(false)}>
                            <NavLink to="/notifications">Voir toutes les notifications</NavLink>
                        </div>
                    </li>
                </ul>
            </PopoverContent>
        </Popover>
    );
}
